<template>
<div class="list">
  <van-nav-bar
    :title="'模拟考试'"
    left-arrow
    fixed
    @click-left="onClickLeft"
  />
    <el-select
    v-model="form.curriculumid"
    filterable @change="coursechoice($event,'')"
    placeholder="请选择课程" style="width: 100%">
    <el-option
      v-for="item in kcOptions"
      :key="item.curriculumid+''"
      :label="item.kcmc+'['+item.kch+']'"
      :value="item.curriculumid+''">
    </el-option>
  </el-select>&nbsp;
  <van-loading style="text-align: center" type="spinner" v-if="loading" color="#1989fa" />
  <van-row v-for="(m,n) in form.dynamicItem" :key="n" class="itemlx">
    <van-col span="8"><p>{{m.examtypedesc}}</p></van-col>
    <van-col span="8"><p>{{m.zts}}道</p></van-col>
    <van-col span="8"> <van-field v-model="m.lxts" @change="jc($event,m)" type="digit" placeholder="抽题数"   /></van-col>
  </van-row>
  <div style="height: 30px"></div>
  <van-tabbar   active-color="#7d7e80">
    <van-tabbar-item icon="share" @click="submitForm">开始练习</van-tabbar-item>
  </van-tabbar>
</div>
</template>

<script>
    import {Notify} from "vant";
    export default {
      data(){
        return{
          //表单
          form:{
            examtypedesc:null,
            dynamicItem:[],
            curriculumid:null,
            kcmc:null,
          },
          formts:{
            curriculumid:null,
          },
          loading:false,
          //课程option
          kcOptions:[],
        }
      },
      created() {
        this.getkcoption();
      },
      methods:{
           onClickLeft() {
             this.$router.go(-1)
           },
           //获取课程信息
           getkcoption() {
             let params = {pageNum: 1, pageSize: 30000}
             this.$ajax.get('/system/curriculum/listinfo', params).then(res => {
               if (res.code === 200) {
                 this.kcOptions = res.rows;
               }
             });
           },
           jc(value,item){
             if(parseInt(item.lxts) > parseInt(item.zts)){
               Notify({ type: 'danger', message: '不能超过总题数'});
               item.lxts = "";
               return;
             }
           },
           coursechoice(id,name){
             // vID 是一个数组，循环获取name,根据id
             if (!id && id.length === 0) {
               return ;
             }//这里多选的时候获取name和单选不一样 单选是对象 多选是数组所以...
             let that = this;
             for(let i=0;i<that.kcOptions.length;i++)
             {
                if(that.kcOptions[i].curriculumid == id)
                {
                  this.form.kcmc = that.kcOptions[i].kcmc+'['+that.kcOptions[i].kch+']';
                  continue;
                }
             }
             this.form.curriculumid = id+'';
             this.getinfotypeList();
           },
           getinfotypeList() {
             let _this=this;
             _this.loading = true;
             _this.formts.curriculumid = _this.form.curriculumid;
             _this.form.dynamicItem = [];
             let params = {params:_this.formts}
             _this.$ajax.get('/student/lianxi/listInfotype',params).then(response => {
               for(var i = 0;i < response.rows.length;i++) {
                 if (_this.form.dynamicItem == undefined) {
                   _this.form.dynamicItem = new Array();
                 }
                 if (response.rows[i].examTypeId != '5' && parseInt(response.rows[i].examTypeId) <= 9) {
                   let obj = {};
                   obj.examtypeid = response.rows[i].examTypeId;
                   obj.examtypedesc = response.rows[i].examtypedesc;
                   obj.lxts = 0;
                   obj.zts = response.rows[i].readbz;
                   _this.form.dynamicItem.push(obj);
                 }
               }
               _this.loading = false;
             });
           },
        submitForm(){
          if (this.form.dynamicItem == undefined || this.form.dynamicItem.length == 0) {
            Notify({ type: 'danger', message: '无可选题型'});
            return;
          }
          var ts = 0;
          for(var i = 0;i < this.form.dynamicItem.length;i++){
            if(this.form.dynamicItem[i].examtypeid == ''){
              Notify({ type: 'danger', message: '题型为空'});
              return;
            }
            if(this.form.dynamicItem[i].lxts == ''){
              this.form.dynamicItem[i].lxts = 0;
            }else{
              ts = ts + this.form.dynamicItem[i].lxts;
            }
          }
          if(ts == 0){
            Notify({ type: 'danger', message: '请输入练习题数'});
            return;
          }
          this.$router.push({ name: 'lianxiindex', params: { from: this.form} })
          //this.$refs.paperinfo.getId(this.form);
          //this.$refs.paperinfo.show();
        },
         }
    }
</script>

<style lang="scss" scoped>
  .list{
    margin-top: 4.125rem;
    padding: 0 0.25rem;
    .itemlx{
      background-color: #F8F8F8;
      margin-bottom: .9375rem;
      border-radius: 5px;
      padding: .9375rem 1.25rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/studentpage/zxlianxi.vue